var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-range-picker',{ref:"datepicker",staticClass:"float-left",attrs:{"startDate":_vm.startDate,"endDate":_vm.endDate,"locale-data":_vm.locale,"opens":_vm.opens,"ranges":_vm.ranges},on:{"update":_vm.updateRange}})}
var staticRenderFns = []

export { render, staticRenderFns }